let EducationData = [
  {
    title: "Computing Science (MSc) - Imperial College London",
    date: "Current",
    description: [
      "Key Modules: C++ Programming, Object Oriented programming, Computer Architecture, Operating System, Machine Learning, Computer Vision, Software Engineer Design, Algorithms, and Databases",
      "Group Project: - Voiceless Speech Recognition on Android. I was the group leader and the frontend developer for the project. I have successfully led the team in meeting all the stakeholders’ requirements and developed an android application following the Test-driven development (TDD) cycle",
      "Individual Research Project: - AI to share positive news. The project involves fine tuning of the BERT model for the sentiment analysis of news articles"
    ],
  },
  {
    title: "Civil Engineering (MEng) - Imperial College London",
    date: "2013 - 2017",
    description: [
      "First class honours",
      "Engineering Dean List - Top 10% of cohort",
      "Sparkes-Pippard Prize - Best MEng student in Structural Engineering",
      "Key Modules: Geotechnics, Advanced Soil Mechanics, Foundation Design, Non-linear Structural Mechanics, Concrete and Steel Design",
    ],
  },
];

export default EducationData;
